import { AbstractControl, FormControl, ValidationErrors } from "@angular/forms";
import { conformToMask } from 'angular2-text-mask';
import { Masks } from './masks';

export function cpfCnpjValidator(control: AbstractControl): ValidationErrors | null {
    var reCPF = new RegExp(/[0-9]{3}\.[0-9]{3}\.[0-9]{3}-[0-9]{2}/g);
    var reCNPJ = new RegExp(/[0-9]{2}\.?[0-9]{3}\.?[0-9]{3}\/?[0-9]{4}\-?[0-9]{2}/g);

    var conformedCPF = conformToMask(
        control.value?control.value:'',
        Masks.cpf,
        { guide: false }
    )

    var conformedCNPJ = conformToMask(
        control.value?control.value:'',
        Masks.cnpj,
        { guide: false }
    )

    if (control.value != undefined && control.value != null && control.value != '') {

        let numbers = control.value.match(/\d/g);
        let numberLength = 0;
        if (numbers) {
            numberLength = numbers.join("").length;
        }
        if (numberLength > 11 && !reCNPJ.test(conformedCNPJ.conformedValue))
            return {
                cnpj: true,
                mensagem:(campo:string)=>`O campo <b>${campo}</b> não é um CNPJ válido`
            }
        else
            if (numberLength <= 11 && !reCPF.test(conformedCPF.conformedValue))
                return {
                    cpf: true,
                    mensagem:(campo:string)=>`O campo <b>${campo}</b> não é um CPF válido`
                }
    }
    return null;
}

